import React, {
	CSSProperties,
	useCallback,
	useEffect,
	useRef,
	useState,
} from "react";
import { useTranslation } from "react-i18next";
import VelavuItemIcon from "../../elements/velavu-item-icon";
import * as styles from "./tab-asset-manage-image.module.scss";
import { AssetCategory } from "velavu-js-api";

interface TabAssetManageImageProps {
	id: string;
	style?: CSSProperties;
	image?: string;
	category?: string;
	canWrite?: boolean;
	onDeleteImage?: () => void;
	onUploadImage?: (imageData: Blob) => void;
}

export default function TabAssetManageImage(props: TabAssetManageImageProps) {
	const { t } = useTranslation();
	const [image, setImage] = useState<string | undefined>(undefined);
	const imageInput = useRef<HTMLInputElement>(null);

	const onChangeImage = useCallback(
		(event: React.FormEvent<HTMLInputElement>) => {
			const imageData = event.currentTarget.files![0];
			props.onUploadImage?.(imageData);
		},
		[props.onUploadImage],
	);

	const handleUploadClick = useCallback(() => {
		imageInput.current?.click();
	}, []);

	const renderImage = useCallback(() => {
		if (image) {
			return <img className={styles.image} src={image} alt="" />;
		} else if (props.category === "VEHICLE") {
			return (
				<VelavuItemIcon data={{ category: AssetCategory.Vehicle }} />
			);
		} else if (props.category === "PERSON") {
			return <VelavuItemIcon data={{ category: AssetCategory.Person }} />;
		} else {
			return (
				<VelavuItemIcon data={{ category: AssetCategory.Equipment }} />
			);
		}
	}, [image, props.category]);

	useEffect(() => setImage(props.image), [props.image]);

	return (
		<div className={styles.container} style={props.style}>
			<div className={styles.content}>{renderImage()}</div>
			{props.canWrite && (
				<>
					<button
						className={styles.imageButton}
						onClick={handleUploadClick}
					>
						{image
							? t("settings.user.upload_new_photo")
							: t("settings.user.upload_photo")}
					</button>
					{image && (
						<div>
							<span className={styles.bulletPoint} />
							<button
								className={styles.imageButton}
								onClick={props.onDeleteImage}
							>
								{t("settings.user.remove_photo")}
							</button>
						</div>
					)}
					<input
						className={styles.imageInput}
						ref={imageInput}
						onChange={onChangeImage}
						type="file"
						name="image"
						accept="image/png, image/jpeg"
					/>
				</>
			)}
		</div>
	);
}
